import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiScoreSuggestionType,
  BackendMutationScoreVariationTextArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ScoreVariationText(
    $variationId: ID!
    $text: String!
    $scoringMethod: ScoringMethodInput
  ) {
    scoreVariationText(variationId: $variationId, text: $text, scoringMethod: $scoringMethod) {
      score
      contentTaxonomyId
      ageScoreHistogram
      genderScoreHistogram
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        type
        name
      }
      secondaryScoringMethod {
        id
        type
        name
      }
    }
  }
`;

type Variables = BackendMutationScoreVariationTextArgs;
type Result = BackendMultiScoreSuggestionType;

export const scoreVariationText = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
